import React from 'react'
import MaterialSymbol from '../material-symbol'

const WorkspacePremium = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="workspace_premium" {...props} />
))

WorkspacePremium.displayName = 'WorkspacePremium'

export default WorkspacePremium
